module.exports = __webpack_public_path__ + "static/img/back.59f739d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page2/back.png
// module id = 1uCV
// module chunks = 0